import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AccessHistory } from '../../../classroom360/system-settings/system-settings-v9/upgrade-access-history/access-history-sub-tab/access-history-sub-tab.model';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { LoginService } from '../login.service';



@Component({
  selector: 'app-audit-logins',
  templateUrl: './audit-logins.component.html',
  styles: [
  ]
})
export class AuditLoginsComponent implements OnInit {
  errors: ErrorList[] = [];
  @ViewChild('yournameRef', { read: ElementRef, static: true }) yournameRef: ElementRef;
  @ViewChild('typeRef', { read: ElementRef, static: true }) typeRef: ElementRef;
  @ViewChild('descriptionRef', { read: ElementRef, static: true }) descriptionRef: ElementRef;
 

  auditLogin = new AccessHistory();
  constructor(
    private dialogRef: MatDialogRef<AuditLoginsComponent>,
    private loginservice: LoginService,
  ) { }

  ngOnInit(): void {
  }
  nextClick() {
    this.validateField();
    if (this.errors.length == 0) {
      this.auditLogin.IsAdminLogin = true;
      this.loginservice.saveTylerAccessHistory(this.auditLogin).subscribe(result => {
        this.dialogRef.close();
      });
    }

  }
  validateField() {
    this.errors = [];
    
    if (this.auditLogin.AddedBy == null || this.auditLogin.AddedBy == '') {
      this.errors.push({
        fieldName: 'Your Name',
        fieldRef: this.yournameRef,
        errorMsg: 'Field is required'
      });

      this.yournameRef.nativeElement.focus();

    }
    if (this.auditLogin.Type == null || this.auditLogin.Type == '') {
      this.errors.push({
        fieldName: 'Type',
        fieldRef: this.typeRef,
        errorMsg: 'Field is required'
      });
     this.typeRef.nativeElement.focus();

    }

    if (this.auditLogin.Description == null || this.auditLogin.Description.toString() == '' ) {
     
      this.errors.push({
        fieldName: 'Description',
        fieldRef: this.descriptionRef,
        errorMsg: 'Field is required'
      });

      this.descriptionRef.nativeElement.focus();
      this.yournameRef.nativeElement.focus();

    }   
    
  }


}
